module.exports = __webpack_public_path__ + "static/img/3_2_3.c24b708a.jpg";